import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Widgets from "./Widgets";
import AbsencesToday from "./AbsencesToday";
import PaiementsWidget from "./PaiementsWidget";
import EvenementsWidget from "./EvenementsWidget";
import RecentActivity from "./RecentActivity";
import AbsencesChart from "./AbsencesChart";
import NotesChart from "./NotesChart";

const Dashboard = () => {
  useEffect(() => {
    document.title = "Tableau de bord | Leaders Ecole Privée";
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Widgets />
          </Row>
          <Row>
            <AbsencesToday />
            <PaiementsWidget />
          </Row>
          <Row>
            <AbsencesChart />
            <NotesChart />
          </Row>
          <Row>
            <EvenementsWidget />
            <RecentActivity />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
